import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import LeftPanel from '@/components/auth/left-panel';
import { Button } from '@/components/ui/button';

export default function WelcomePage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className='flex min-h-screen bg-ws-bg'>
      <LeftPanel showWelcomeContent />

      {/* Right: question + actions */}
      <div className='flex flex-1 items-center justify-center px-6'>
        <div className='w-full max-w-[320px] space-y-8'>
          {/* Mobile logo (hidden on desktop where left panel shows it) */}
          <div className='flex flex-col items-center gap-4 lg:hidden'>
            <img
              src={`${import.meta.env.BASE_URL}images/agavi-logo.svg`}
              alt='Agavi'
              className='w-20 h-20'
            />
            <div className='text-center'>
              <h1 className='text-3xl font-bold text-ws-text'>
                {t('auth.welcome.title')}
              </h1>
              <p className='mt-2 text-sm text-ws-muted'>
                {t('auth.welcome.subtitle')}
              </p>
            </div>
          </div>

          {/* Question */}
          <div className='text-center space-y-2'>
            <h2 className='text-2xl font-semibold text-ws-text'>
              {t('auth.welcome.question')}
            </h2>
            <p className='text-base text-ws-muted'>
              {t('auth.welcome.description')}
            </p>
          </div>

          {/* Actions */}
          <div className='space-y-4'>
            <Button variant='primary' size='lg' block onClick={() => navigate('/signup')}>
              {t('auth.welcome.newUser')}
            </Button>
            <Button variant='secondary' size='lg' block onClick={() => navigate('/login')}>
              {t('auth.welcome.existingUser')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
